import { Grid, Typography, Box, Paper } from "@mui/material";
import { useState, useEffect } from "react";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import iconWashroom from "../../../../assets/SvgIcons/icons-washroom.svg";
import iconMob from "../../../../assets/SvgIcons/ico-mobility.svg";
import iconBlind from "../../../../assets/SvgIcons/ico-blind.svg";
import CustomBox from "../Common/CustomBox";
import Card from "../Common/Card";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import { BlockGridGraph } from "../BuildingBetterCourtsData";

// Dummy data for the cards
const cardDataStatic = [
  { statistics: "50%", icon: iconMob, content: "RAMP & LIFTS" },
  { statistics: "50%", icon: iconBlind, content: "VISUAL AID" },
  { statistics: "50%", icon: iconWashroom, content: "WASHROOMS" },
];

const faqsStatic = [
  {
    content: "Are there washrooms for persons with disabilities?",
    status: "No",
  },
  {
    content: "Are the courtrooms accessible via ramps/lifts?",
    status: "Yes",
  },
  {
    content: "- Ramp at atleast one entry point into the court complex?",
    status: "Yes",
  },
  {
    content: "- Ramp at atleast one entry point into the court building?",
    status: "Yes",
  },
  {
    content: "- Ramp present for all floors of court building?",
    status: "Yes",
  },
  {
    content: "- Are there lifts to all floors?",
    status: "Yes",
  },
  {
    content: "Are there tactile pavements at entry?",
    status: "Yes",
  },
  {
    content: "Are there braille notices at entry?",
    status: "Yes",
  },
  {
    content: "Are there tactile pavements inside the court complex?",
    status: "Yes",
  },
  {
    content: "Are there braille notices inside the court complex?",
    status: "Yes",
  },
];

export const BarrierFreeAccess = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { theme, loader } = useCustomLogic();
  let isDistrict = selectedDistrict === "Select District";

  const [cardData, setCardData] = useState(cardDataStatic);
  const [faqs, setFaqs] = useState(faqsStatic);

  useEffect(() => {
    if (dataState && Object.keys(dataState).length > 0) {
      let arr = [
        dataState?.ramp_lifts ?? 0,
        dataState?.visual_aid ?? 0,
        dataState?.disabled_washrooms ?? 0,
      ];
      setCardData(
        cardDataStatic.map((item, index) => ({
          ...item,
          statistics: `${arr[index]}%`,
        }))
      );
    }
    if (dataDistrict && Object.keys(dataDistrict).length > 0) {
      let arr = [
        dataDistrict?.washroom_for_disabled,
        "",
        dataDistrict?.ramp_present,
        dataDistrict?.ramp_present_at_main_court_building,
        dataDistrict?.ramp_present_for_all_floors,
        dataDistrict?.court_building_has_lift,
        dataDistrict?.tactile_pavement_court_complex,
        dataDistrict?.notices_in_braille_court_complex,
        dataDistrict?.tactile_pavement_court_building,
        dataDistrict?.notices_in_braille_court_building,
      ];

      setFaqs(faqsStatic.map((item, index) => ({ ...item, status: arr[index] })));
    }
  }, [dataState, dataDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict && (
            <Box>
              <Typography variant="regular3" color="secondary.main">
                How inclusive is the court complex?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                A barrier-free court complex is one that has ramps present at the main entry and
                within the court complex, or has a working lift to access all floors of the court
                building. In addition, court complexes were studied for their availability of
                tactile pavements and instructions/notices in braille at the entrance and in the
                main building, for those with visual disabilities.
              </Typography>
            </Box>
          )}
          <CustomBox
            content={
              isDistrict ? "BARRIER-FREE ACCESS FEATURES:" : "Is the court complex inclusive?"
            }
            style={{
              fontSize: !isDistrict && "24px",
              padding: !isDistrict && "8px 13px",
              color: !isDistrict && theme.palette.common.black,
              backgroundColor: !isDistrict && "#e6ebf4",
            }}
          />

          {isDistrict ? (
            <Grid container spacing={3} sx={{ padding: "0px" }}>
              {cardData &&
                cardData.map((item, index) => {
                  return (
                    <Grid item xs={12} md={6} lg={6} key={index}>
                      <BlockGridGraph percentage={item?.statistics} color="#F25E5E" />
                      <Card
                        content={item.content}
                        imgSrc={item.icon}
                        statistics={item.statistics}
                      />
                    </Grid>
                  );
                })}
            </Grid>
          ) : (
            faqs &&
            faqs.map((ques, index) => {
              return (
                <FAQ
                  content={ques.content}
                  status={ques.status}
                  isLastItem={index === faqs.length - 1}
                />
              );
            })
          )}
        </Box>
      )}
    </>
  );
};
